module.exports = __webpack_public_path__ + "img/img-estp.f45200c6.jpg";